import { useState } from "react";
import { Button, Input } from "../components";
import { api } from "../lib/api";

interface LoginPageProps {
  onLogin: (token: string) => void;
}

export function LoginPage({ onLogin }: LoginPageProps) {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!password.trim()) return;
    setLoading(true);
    setError("");
    try {
      const { token } = await api.login(password);
      onLogin(token);
    } catch {
      setError("密码错误，请重试");
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "var(--surface-page, #f4f4f5)",
      }}
    >
      <div
        style={{
          width: 360,
          background: "var(--surface-card, #fff)",
          borderRadius: "var(--radius-lg, 12px)",
          boxShadow: "0 4px 24px rgba(0,0,0,0.10)",
          padding: "40px 36px 36px",
        }}
      >
        {/* Logo / title */}
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <div
            style={{
              width: 52,
              height: 52,
              borderRadius: 14,
              background: "var(--brand, #3b82f6)",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: 14,
            }}
          >
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10" />
              <polyline points="12 6 12 12 16 14" />
            </svg>
          </div>
          <div style={{ fontSize: 22, fontWeight: 800, color: "var(--text-strong, #18181b)", letterSpacing: 1 }}>
            记时 JiShi
          </div>
          <div style={{ fontSize: 13, color: "var(--text-subtle, #71717a)", marginTop: 4 }}>
            课时管理系统
          </div>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          <Input
            label="管理密码"
            type="password"
            value={password}
            placeholder="请输入管理密码"
            autoFocus
            onChange={(e) => {
              setPassword(e.target.value);
              if (error) setError("");
            }}
          />

          {error && (
            <div
              style={{
                fontSize: 13,
                color: "var(--danger-fg, #dc2626)",
                background: "var(--status-absent-bg, #fef2f2)",
                border: "1px solid var(--status-absent-fg, #dc2626)",
                borderRadius: "var(--radius-sm, 6px)",
                padding: "8px 12px",
              }}
            >
              {error}
            </div>
          )}

          <Button
            variant="primary"
            type="submit"
            disabled={!password.trim() || loading}
            style={{ width: "100%", marginTop: 4 }}
          >
            {loading ? "验证中…" : "进入系统"}
          </Button>
        </form>
      </div>
    </div>
  );
}
